<template>
  <div>

    <v-dialog
        v-model="showDialog"
        :max-width="maxWidth">

      <v-card class="pa-10">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text v-html="message"></v-card-text>
        <v-card-actions>
          <div>
            <v-btn v-if="!!yesText"
              color="secondary"
              class="secondary--btn mr-4"
              elevation="0"
              @click="_yes">
                {{ yesText }}
            </v-btn>

            <v-btn outlined v-if="!!noText"
              color="tertiary"
              class="tertiary--btn"
              elevation="0"
            @click="_no">
            {{ noText }}
            </v-btn>

            <v-btn v-if="!!okText"
              color="secondary"
              class="secondary--btn mr-4"
              elevation="0"
              @click="_ok">
            {{ okText }}
            </v-btn>

          </div>
        </v-card-actions>
      </v-card>


    </v-dialog>

  </div>
</template>

<script>

  import textKeys from "../constants/display-texts.js";
  import constants from '../constants/generic.js'

  export default {
    name: 'Confirm',
    props: {
      show: { type: Boolean },
      title: { type: String, default: ''}, 
      message: { type: String },
      yesText: { type: String, default: ''}, 
      noText: { type: String, default: ''}, 
      okText: { type: String, default: ''}, 
    },
    emits: ["yesClick", "noClick", "okClick"],
    data: () => ({
      maxWidth: constants.PopUpMaxWidth,
      textKeys: textKeys
    }),
    methods: {
      _yes() {
        this.$emit("yesClick");
      },
      _no() {
        this.$emit("noClick");
      },
      _ok() {
        this.$emit("okClick");
      },
    },
    computed: {
      showDialog: {
        get() { return this.show; },
        set(value) { if (!value) this.$emit("noClick"); } 
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>